import React, { useState } from 'react';
import propTypes from 'prop-types';

import Review from '../ReviewPage/Review';
import { FormStepper } from '../FormStepper';
import { BasicDetails } from '../Steps/BasicDetails';
import { PanelDetails } from '../Steps/PanelDetails';
import { QuestionDetails } from '../Steps/QuestionDetails';
import { PostExposureSurvey } from '../Steps/PostExposureSurveyDetails';
import { ScreeningSurvey } from '../Steps/ScreeningSurveyDetails';
import { useSelector } from 'react-redux';
export default function CustomStudyStepper({
  onAddNewStudySubmit,
  languageTypes,
  environmentData,
  locationTypes,
  mediaData,
  questionTypes,
  studyTypes,
  respondentTypes,
  defaultValues,
  basicDetailsValidationSchema,
  panelDetailsValidationSchema,
  questionDetailsValidationSchema,
  screeningSurveyValidationSchema,   
  postExposureValidationSchema,  
  history,
}) {
  const [stepImperatively, setStepImperatively] = useState(null);


  
const companyUsersRaw = useSelector((state) => state.studyData.companyUsers);

const safeUsers = Array.isArray(companyUsersRaw)
  ? companyUsersRaw
  : Array.isArray(companyUsersRaw?.data)
    ? companyUsersRaw.data
    : [];

const userOptions = safeUsers.map((u) => ({
  id: u.user_id || u.id,
  name: u.first_name && u.last_name
    ? `${u.first_name} ${u.last_name}`
    : u.name || u.username,
  description: u.email || "",
}));
const loggedInUser = useSelector((state) => state.userData.userData);


  return (
    <FormStepper 
      stepImperatively={stepImperatively}
      setStepImperatively={setStepImperatively}
      initialValues={{
        ...defaultValues,
        media_id: mediaData.data.find((media) => media.code === 4),
        study_type_id: 14,
        // study_type_id: studyTypes.data.find((study) => study.code === 0)?.id,
        override_owner_id: loggedInUser?.user_id || null,
        panel_seconds_before_move_next: -1,
      }}
      onSubmit={async (values) => {
        await onAddNewStudySubmit(values, history);
      }}
    >
      <BasicDetails 
        title='Tell us about your study'
        label='Basic Details'
        validationSchema={basicDetailsValidationSchema}
        {...{
          environmentData,
          locationTypes,
          languageTypes,
          studyTypes,
          mediaData,
          respondentTypes,
          includeStudyType: true,
          includeMediaType: true,
          userOptions,
        }}
      />
      {/* <QuestionDetails
        validationSchema={questionDetailsValidationSchema}
        title='What surveys will you use?'
        label='Question Details'
        {...{questionTypes }}
      /> */}
        <ScreeningSurvey
        title="What screening survey will you use?"
        label="Screening Survey"
        validationSchema={screeningSurveyValidationSchema}
        {...{ questionTypes }}
      />
      <PanelDetails
        title='Tell us about your recruitment'
        label='Panel Details'
        validationSchema={panelDetailsValidationSchema}
      />
        <PostExposureSurvey
        title="What post-exposure survey will you use?"
        label="Post Exposure Survey"
        validationSchema={postExposureValidationSchema}
      />
      <Review
        title='Your project is ready for review'
        label='Review'
        setStepImperatively={setStepImperatively}
        labels={[
          'Basic Details',
          'Screening Survey',
          'Panel Details',
          'Post Exposure Survey'
        ]}
      />
    </FormStepper>
  );
}

CustomStudyStepper.propTypes = {
  onAddNewStudySubmit: propTypes.func,
  languageTypes: propTypes.object,
  environmentData: propTypes.object,
  locationTypes: propTypes.object,
  mediaData: propTypes.object,
  questionTypes: propTypes.object,
  studyTypes: propTypes.object,
  respondentTypes: propTypes.object,
  defaultValues: propTypes.object,
  basicDetailsValidationSchema: propTypes.object,
  panelDetailsValidationSchema: propTypes.object,
  questionDetailsValidationSchema: propTypes.object,
  history: propTypes.object,

};
